import React from "react";
import "./ProgressCircle.scss";
import Loader from "../../assets/lottie/loader.json";
import Lottie from "react-lottie-player";

interface IProps {
    progress: number;
}


export function ProgressCircle({ progress }: IProps) {

    return <Lottie className="progress-circle-lottie" animationData={Loader} goTo={progress} style={{ height: '100vh', width: '100vw'}}  />
}
